import { Logger }           from '../../../shared/utils/logger.js'
import { appendSvgHeightWidth, appendSvgStyle } from '../../../shared/utils/svgUtils.js'

/**
 * processTierSvg
 *
 * Mutates a parsed SVG element in-place (adds class, style, dimensions),
 * validates structure, then returns the serialized outer HTML string.
 * Returns null if the SVG is structurally invalid.
 *
 * @param {SVGSVGElement} svgElement  — root <svg> from DOMParser output
 * @returns {string | null}
 */
export function processTierSvg(svgElement) {
  if (!svgElement) return null

  // ── Font-size from viewBox ─────────────────────────────────────────────────
  const viewBox   = svgElement.getAttribute('viewBox')
  const svgWidth  = viewBox ? Number(viewBox.split(' ')[2]) : 1600
  const fontSize  = (svgWidth / 1600) * 25

  // ── Injected CSS ───────────────────────────────────────────────────────────
  const cssText = `
    .tier .tag {
      font-size: ${fontSize}px !important;
    }
    .tier path.interior {
      fill: white;
      stroke: #ccc;
      stroke-width: 1;
      transition: fill 0.15s ease-in-out, stroke 0.15s ease-in-out, opacity 0.15s ease-in-out;
    }
  `

  appendSvgHeightWidth(svgElement)
  appendSvgStyle(svgElement, cssText)
  svgElement.setAttribute('class', 'tier')

  // ── Validation ─────────────────────────────────────────────────────────────
  const buildingTierGroup = svgElement.querySelector('g.building_tier')

  if (
    svgElement.children.length === 0 ||
    !buildingTierGroup ||
    buildingTierGroup.children.length === 0
  ) {
    Logger.error({
      message: 'processTierSvg: SVG is empty or missing g.building_tier',
      content: JSON.stringify({
        hasGroup:      !!buildingTierGroup,
        childrenCount: buildingTierGroup?.children.length ?? 0,
      }),
    })
    return null
  }

  return svgElement.outerHTML
}
